import { Col, Spin } from "antd";
import {
  InitialFieldsAlignment,
  Signatory,
  Signature,
} from "@type/core/dashboard/dashboard.types";
import React, { Dispatch, SetStateAction } from "react";
import { Member } from "@type/core/offices/offices.types";
import RightPanelSignatures from "@components/core/pdf/rightpanel/RightPanelSignatures";
import RightPanelInitialFields from "@components/core/pdf/rightpanel/RightPanelInitialFields";
import { TransactionType } from "@type/core/transaction/transaction.types";

interface PdfContainerLeftPanelProps {
  src: string | undefined;
  loading: boolean;
  index: number;
  signatories: Signatory[];
  signatures: Signature[];
  transactionType: TransactionType;
  members: Member[];
  setManualPositioning: Dispatch<SetStateAction<boolean>>;
  isInitialFieldsActivated: boolean;
  initialFieldsY: number;
  initialFieldsAlignment: InitialFieldsAlignment;
  filename: string;
  officeId: string;
  pageNumber: number;
  numberOfFiles: number;
  buttonLoading?: boolean;
  setIsInitialFieldsActivated: (activated: boolean) => void;
}

const PdfContainerRightPanel: React.FC<PdfContainerLeftPanelProps> = ({
  src,
  index,
  loading,
  signatories,
  transactionType,
  signatures,
  members,
  officeId,
  setManualPositioning,
  pageNumber,
  numberOfFiles,
  buttonLoading,
  isInitialFieldsActivated,
  initialFieldsY,
  initialFieldsAlignment,
  filename,
  setIsInitialFieldsActivated,
}: PdfContainerLeftPanelProps) => {
  return (
    <Col span={24} sm={12} id={"rightPanel_" + index}>
      {!loading ? (
        <div className="row d-flex flex-column">
          <RightPanelSignatures
            src={src}
            loading={loading}
            index={index}
            signatories={signatories}
            buttonLoading={buttonLoading}
            signatures={signatures}
            transactionType={transactionType}
            members={members}
            setManualPositioning={setManualPositioning}
            filename={filename}
            officeId={officeId}
            pageNumber={pageNumber}
            numberOfFiles={numberOfFiles}
          />
          {transactionType === "signature" && (
            <>
              <div className="row spacer" />
              <RightPanelInitialFields
                index={index}
                isInitialFieldsActivated={isInitialFieldsActivated}
                initialFieldsY={initialFieldsY}
                initialFieldsAlignment={initialFieldsAlignment}
                filename={filename}
                pageNumber={pageNumber}
                numberOfFiles={numberOfFiles}
                setIsInitialFieldsActivated={setIsInitialFieldsActivated}
              />
            </>
          )}
        </div>
      ) : (
        <div className="h-100 flex-grow-1 d-flex align-items-center justify-content-center">
          <Spin />
        </div>
      )}
    </Col>
  );
};

export default PdfContainerRightPanel;
